import FormularioFuturasTareas from "./FormularioFuturasTareas";

const AgregarFuturaTarea = () => {
  return (
    <div>
      <div className="container mt-4">
        <h1 className="text-center mb-4">Agregar Nueva Tarea Futura</h1>
        <FormularioFuturasTareas id={null} tarea={null} />
      </div>
    </div>
  );
};

export default AgregarFuturaTarea;
